import { VairSportRating } from 'constants/payloads/vair/playerSearch';

export interface ParsedVairRating {
  /** Numeric rating value (e.g. 3.915) */
  value: number | null;
  /** Truncated to 2 decimals to mirror VAIR's display (e.g. '3.91') */
  formattedValue: string | null;
  /** Rating abbreviation (e.g. 'VO') */
  abbr: string | null;
}

export const parseVairSportRating = (
  sportRating: VairSportRating | undefined | null,
): ParsedVairRating => {
  if (!sportRating) return { value: null, formattedValue: null, abbr: null };
  // Truncate (never round) to 2 decimals to match what VAIR shows — rounding
  // half-up would display a higher rating than VAIR (e.g. 2.25 -> "2.3"). The
  // small epsilon guards against float representation under-truncating a value
  // that's a hair below its true 2-decimal form (e.g. 2.26 stored as 2.2599…).
  const truncated = Math.floor(sportRating.rating * 100 + 1e-9) / 100;
  return {
    value: sportRating.rating,
    formattedValue: truncated.toFixed(2),
    abbr: sportRating.abbr,
  };
};

/** Returns a display string like "3.915 VO", or null if no rating. */
export const formatVairRating = (
  sportRating: VairSportRating | undefined | null,
): string | null => {
  if (!sportRating) return null;
  return `${sportRating.rating} ${sportRating.abbr}`;
};
